<div class="row">
  <div class="col-md-5">
    <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
    </lib-filtro>
  </div>
</div>
<div class="row" *ngIf="lista && lista.length === 0">
  <div class="col-12">
    <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
    <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
  </div>
</div>
<div class="row" *ngIf="lista && lista.length > 0">
  <div class="col-12 table-responsive">
    <table class="table table-eddy">
      <thead>
        <tr>
          <th scope="col" class="text-center">Cód.</th>
          <th scope="col">Nome</th>
          <th scope="col">E-mail</th>
          <th scope="col">CPF</th>
          <th scope="col">Telefone</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of lista">
          <td class="text-center">{{item.id}}</td>
          <td>{{item.nome}} {{item.sobrenome}}
            <span class="d-block small text-muted">{{item.favorecido?.nome}}</span>
          </td>
          <td>{{item.email}}</td>
          <td>{{item.cpf | CPF}}</td>
          <td>{{item.telefone | TELEFONE}}</td>
          <td>
            <span *ngIf="item.ativo && !item.administrador && !item.solicitacao && !item.convidado"
              class="badge badge-success">Ativo</span>
            <span *ngIf="item.ativo && !item.administrador && !item.solicitacao && item.convidado"
              class="badge badge-secondary">Convidado</span>
            <span *ngIf="item.ativo && item.administrador" class="badge badge-primary">Administrador</span>
            <span *ngIf="!item.ativo && item.solicitacao" class="badge badge-warning">Pendente</span>
            <span *ngIf="!item.ativo && !item.solicitacao" class="badge badge-danger">Inativo</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row float-right" *ngIf="lista && lista.length > 0">
  <div class="col-12 mb-5">
    <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal" (paginaAnterior)="paginaAnterior()"
      (proximaPagina)="proximaPagina()"></lib-paginacao>
  </div>
</div>
<br>